import connect from "@classdojo/web/utils/hoc/connect";
import IdeasDisplay from "./IdeasDisplay";
import { IdeasSlice, sendVideoPlaybackState } from "src/pods/ideas";
import { displayClose } from "src/pods/realtime";

type IdeasDisplayContainerState = {
  ideas: IdeasSlice;
};
const mapStateToProps = (state: IdeasDisplayContainerState) => {
  return {
    ...state.ideas,
  };
};

const mapDispatchToProps = {
  sendVideoPlaybackState,
  displayClose,
};

export default connect(mapStateToProps, mapDispatchToProps)(IdeasDisplay);
